import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { NetzzuordnungenPageComponent } from './netzzuordnungen-page/netzzuordnungen-page.component';

export const netzzuordnungenRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzzuordnungen
        path: 'list',
        component: NetzzuordnungenPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(netzzuordnungenRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class NetzzuordnungenRoutingModule {
}
